homeHandler = {
    $nextSectionArrow: $('.next-section-arrow'),
    fullpageController: null,

    resizeHero: function() {
        if (Foundation.MediaQuery.atLeast('medium')) {
            $('main').css('margin-top', 0);
            // 20201028 auto height is removed because next arrow is removed
            // var logoImages = $('.hero-outer .logo-container img');
            // var logoHeight = $(window).height() - 2 * $('.next-arrow-container').outerHeight();
            // logoImages.css('height', logoHeight);
        }
    },

    init: function() {
        var self = this;

        if ($('body.page-template-page-home').length == 0) return;

        $(window).on('resize', function() {
            self.resizeHero();
        }).trigger("resize");

        this.$nextSectionArrow.on('click', function(e) {
            e.preventDefault();
            
            var url = $(this).attr("href");
            if (url.includes('#')) {
                e.preventDefault();
                if ($(url).length !== 0) {
                    $([document.documentElement, document.body]).animate({
                    	scrollTop: $(url).offset().top
                    }, 'slow');
                }
            }
        });

        // adjust top padding for each section because some of its top part will 
        // be covered by navigation
        // exception are hero and footer
        $('.fullpage-container .section').not('.endorse-container').not('.home-footer-container').each(function() {
            var topPadding = parseInt($(this).find('.section-inner').css('padding-top'));
            var headerHeight = $('header').outerHeight();
            if (Foundation.MediaQuery.only('small')) {
                // $(this).find('.section-inner')
                //     // .css('padding-top', '0px')
                //     .css('margin-top', -headerHeight);
            } else {
                $(this).find('.section-inner').css('padding-top', (topPadding + headerHeight)+'px');
            }
        });

        if (Foundation.MediaQuery.atLeast('medium')) {
            // 20211024 cancel fullPage
            /*
            this.fullpageController = $('.fullpage-container').fullpage({
                scrollOverflow: true,
                onLeave: function(origin, destination, direction) {
                    // hide menu on first section
                    if (destination.index == 0 && direction == 'up') {
                        $('header').addClass('headroom--top');
                    } else {
                        $('header').removeClass('headroom--top');
                    }
                }
            });
            */    
        }
    }
}